import { portableSelection } from "./studioGroups";
import { bounds } from "./studioModel";

export function transferToPage(doc, selected, targetId, position) {
  const target = doc.pages.find((p) => p.id === targetId);
  if (!target) return doc;
  const all = doc.pages.flatMap((p) => p.elements);
  const ids = new Set(all.filter((n) => selected.includes(n.id) && !n.locked).map((n) => n.id));
  all.forEach((n) => { if (ids.has(n.attachedTo)) ids.add(n.id); });
  const splitRows = new Set(all.filter((n) => n.inlineRow && ids.has(n.id) && all.some((other) => other.inlineRow?.id === n.inlineRow.id && !ids.has(other.id))).map((n) => n.inlineRow.id));
  const disconnectSplitRow = (n) => splitRows.has(n.inlineRow?.id) ? { ...n, inlineRow: undefined } : n;
  const moving = all.filter((n) => ids.has(n.id));
  if (!moving.length) return doc;
  const box = bounds(moving);
  const x = Math.max(0, Math.min(position?.x ?? box.x, Math.max(0, target.width - box.w)));
  const y = Math.max(0, Math.min(position?.y ?? box.y, Math.max(0, target.height - box.h)));
  const moved = portableSelection(all, [...ids]).map(disconnectSplitRow).map((n) => ({ ...n, x: n.x + x - box.x, y: n.y + y - box.y,
    attachedTo: ids.has(n.attachedTo) ? n.attachedTo : undefined }));
  return { ...doc, pages: doc.pages.map((p) => ({ ...p,
    elements: [...p.elements.filter((n) => !ids.has(n.id)).map(disconnectSplitRow), ...(p.id === targetId ? moved : [])],
  })) };
}
